import { isAfterBookingToday } from "@shyne/shared";
import type { ApiClient, Appointment } from "@shyne/shared/api";
import { format } from "date-fns";
import type { uuid } from "@/interfaces";
import { appointment_status } from "@/models/appointment.model";
import { CANCELLABLE_STATUSES } from "./appointment-cancellation";

export const RESCHEDULABLE_STATUSES: readonly appointment_status[] = CANCELLABLE_STATUSES;

export const isReschedulable = (status: appointment_status): boolean => RESCHEDULABLE_STATUSES.includes(status);

export const NOT_RESCHEDULABLE_REASON = "Only an appointment whose work has not started can be rescheduled.";

export const calendarDay = (day: Date): string => format(day, "yyyy-MM-dd");

export const isReschedulableDay = (day: Date, currentDate: string, now: Date = new Date()): boolean =>
  calendarDay(day) !== currentDate && isAfterBookingToday(calendarDay(day), now);

type RescheduleApi = Pick<ApiClient["appointments"], "reschedule">;

export type RescheduleRequest = { date: string; actingOrganization: uuid | null };

export function createAppointmentReschedule(api: RescheduleApi) {
  return function reschedule(id: uuid, { date, actingOrganization }: RescheduleRequest): Promise<Appointment> {
    return api.reschedule(id, { date, ...(actingOrganization ? { actingOrganization } : {}) });
  };
}
